export enum BooleanFilter {
	True = 1,
	False = 2,
}
